import React from 'react';
import { FeatureContainer, FeatureButton, FeatureImages } from './CommunityElements';
import twitter from '../../images/twitter.png';
import instagram from '../../images/instagram.png';
import discord from '../../images/discord.png'

const Feature = () => {
  return (
    <FeatureContainer>
      <h1>Community</h1>
      <p>Come and join the CryptoBearsClub community on our journey together!</p>
      <FeatureImages>
        <a href="https://twitter.com/CryptoBearsClub">
          <img src={twitter} alt="twitter" />
        </a>
        <a href="https://instagram.com/Crypt_obears">
          <img src={instagram} alt="instagram" />
        </a>
        <a href="https://discord.com/invite/wztbsWGcnF">
          <img src={discord} alt="discord" />
        </a>
      </FeatureImages>
    </FeatureContainer>
  );
};

export default Feature;
